import React from "react";
import {
  Download,
  FileText,
  ArrowRight,
  ExternalLink,
  Leaf,
  Globe,
  Factory,
} from "lucide-react";

const Sustainability = () => {
  const pdfPath = "/Docs/REPORTE DE SOSTENIBILIDAD.pdf";

  const downloadFilename = "Informe-de-Sostenibilidad-Sierra-Alta-SAS-2025.pdf";

  return (
    <section className="relative overflow-hidden bg-[#f8fafb] py-16 sm:py-20 px-4 sm:px-6 lg:px-8">
      <div className="absolute top-0 right-0 w-[420px] h-[420px] bg-[#ee7d32]/10 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-[300px] h-[300px] bg-[#ee7d32]/5 rounded-full blur-3xl" />
      <div className="relative max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-[1fr_1.05fr] gap-10 xl:gap-14 items-start">
          <div>
            <div className="space-y-5">
              <h1 className="text-4xl md:text-5xl xl:text-[56px] font-bold tracking-tight text-[#111827] leading-[1.05]">
                Sostenibilidad
              </h1>

              <div className="w-20 h-1 rounded-full bg-[#ee7d32]" />
            </div>

            <div className="mt-7 space-y-4 text-[17px] text-[#4b5563] leading-8 max-w-xl">
              <p>
                En <strong>Sierra Alta SAS</strong>, estamos comprometidos con
                prácticas sostenibles que promueven el cuidado del medio
                ambiente y el bienestar de nuestras comunidades. Descarga
                nuestro <strong>Reporte de Sostenibilidad 2025</strong> para
                conocer más sobre nuestras iniciativas y logros.
              </p>
            </div>

            <div className="grid sm:grid-cols-3 gap-4 mt-10">
              <div className="bg-white rounded-2xl p-5 border border-[#ececec] hover:border-[#ee7d32]/30 transition-all duration-300">
                <div className="w-11 h-11 rounded-xl bg-[#ee7d32] flex items-center justify-center mb-4">
                  <Leaf size={22} className="stroke-white" />
                </div>

                <h3 className="font-semibold text-[#111827] text-[15px]">
                  Medio Ambiente
                </h3>

                <p className="text-sm text-[#6b7280] mt-2 leading-relaxed">
                  Gestión ambiental y reducción de impactos.
                </p>
              </div>

              <div className="bg-white rounded-2xl p-5 border border-[#ececec] hover:border-[#ee7d32]/30 transition-all duration-300">
                <div className="w-11 h-11 rounded-xl bg-[#ee7d32] flex items-center justify-center mb-4">
                  <Globe size={22} className="stroke-white" />
                </div>

                <h3 className="font-semibold text-[#111827] text-[15px]">
                  Comunidades
                </h3>

                <p className="text-sm text-[#6b7280] mt-2 leading-relaxed">
                  Impacto positivo y desarrollo social sostenible.
                </p>
              </div>

              <div className="bg-white rounded-2xl p-5 border border-[#ececec] hover:border-[#ee7d32]/30 transition-all duration-300">
                <div className="w-11 h-11 rounded-xl bg-[#ee7d32] flex items-center justify-center mb-4">
                  <Factory size={22} className="stroke-white" />
                </div>

                <h3 className="font-semibold text-[#111827] text-[15px]">
                  Operaciones
                </h3>

                <p className="text-sm text-[#6b7280] mt-2 leading-relaxed">
                  Procesos eficientes y compromiso corporativo.
                </p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 mt-10">
              <a
                href={pdfPath}
                download={downloadFilename}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-[#ee7d32] hover:bg-[#d96d24] text-white px-6 py-3.5 rounded-xl font-medium transition-all duration-300"
              >
                <Download size={18} stroke="white"/>
                Descargar Reporte
              </a>

              <a
                href={pdfPath}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-white border border-[#e5e7eb] hover:border-[#ee7d32] hover:text-[#ee7d32] text-gray-700 px-6 py-3.5 rounded-xl font-medium transition-all duration-300"
              >
                <ExternalLink size={18} />
                Ver Reporte
              </a>
            </div>
          </div>

          <div className="relative">
            <div className="absolute -inset-2 bg-[#ee7d32]/5 blur-2xl rounded-[32px]" />

            <div className="relative bg-white rounded-3xl overflow-hidden border border-[#ececec] shadow-lg">
              <div className="hidden md:block h-[680px] bg-[#fafafa]">
                <iframe
                  src={`${pdfPath}#view=FitH&toolbar=1`}
                  title="Reporte de Sostenibilidad"
                  className="w-full h-full"
                  loading="lazy"
                  style={{ border: "none" }}
                />
              </div>

              <div className="md:hidden p-5">
                <div className="relative overflow-hidden rounded-2xl">
                  <img
                    src="/images/sustainability/reporte-preview.webp"
                    alt="Reporte de Sostenibilidad"
                    className="w-full h-full object-cover"
                  />

                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/30 to-transparent flex flex-col items-center justify-center text-center p-6">
                    <div className="w-16 h-16 rounded-2xl bg-white/20 backdrop-blur-sm flex items-center justify-center mb-4">
                      <FileText size={36} stroke="white"/>
                    </div>

                    <h4 className="text-2xl font-bold text-white">
                      Reporte 2025
                    </h4>

                    <p className="text-white/90 mt-3 text-sm leading-relaxed max-w-xs">
                      Descubre nuestras iniciativas y avances en sostenibilidad
                      y responsabilidad corporativa.
                    </p>

                    <a
                      href={pdfPath}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="mt-6 inline-flex items-center gap-2 bg-[#ee7d32] hover:bg-[#d96d24] text-white px-5 py-3 rounded-xl font-medium transition-all duration-300"
                    >
                      Abrir PDF
                      <ArrowRight size={16} />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="mt-6 flex justify-end">
          <a
            href="/contact-us?division=otro"
            className="group flex items-center gap-2 text-sm font-medium text-[#f37021] hover:text-orange-600 transition"
          >
            ¿Necesitas más información?
            <span className="w-6 h-[2px] bg-[#f37021] group-hover:w-10 transition-all" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Sustainability;
